// Menu « / » en français (03/10) : les libellés des commandes sont traduits à l'affichage (t()),
// mais la recherche ne connaissait que le nom anglais d'origine (« /joindre » ne trouvait rien,
// seul « /attach » marchait). On cherche désormais dans l'original ET dans sa traduction, sans
// tenir compte des accents ni des majuscules.

import { t } from "@app/lib/compta/i18n";
import { removeDiacritics } from "@app/lib/utils";

/** Forme de comparaison : minuscules, sans accents (« Compétence » → « competence »). */
export function normaliserRecherche(texte: string): string {
  return removeDiacritics(texte).toLowerCase();
}

/** Formes cherchables d'un texte : l'original (anglais) et sa traduction affichée. */
function formesCherchables(texte: string | undefined): string[] {
  if (texte === undefined) {
    return [];
  }
  const traduit = t(texte);
  return traduit === texte
    ? [normaliserRecherche(texte)]
    : [normaliserRecherche(texte), normaliserRecherche(traduit)];
}

/** Vrai si la requête est contenue dans l'un des textes, en anglais ou en français. */
export function correspondALaRecherche(
  textes: (string | undefined)[],
  requete: string
): boolean {
  const q = normaliserRecherche(requete.trim());
  if (q.length === 0) {
    return true;
  }
  return textes.flatMap(formesCherchables).some((forme) => forme.includes(q));
}
